import { render, staticRenderFns } from "./KPISetup.vue?vue&type=template&id=08e5e52e&scoped=true"
import script from "./KPISetup.vue?vue&type=script&lang=js"
export * from "./KPISetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5e52e",
  null
  
)

export default component.exports